import { Route, Switch, BrowserRouter } from "react-router-dom";

import "assets/css/app.css";
import HomePage from "./pages/HomePage";
import Details from "./pages/Details";
import Cart from "./pages/Cart";
import Congratulation from "./pages/Congratulation";
import NotFound from "./pages/NotFound";

import Provider from "helpers/hooks/useGlobalContext";
function App() {
  return (
    <BrowserRouter>
      <Provider>
        <Switch>
          <Route exact path="/" component={HomePage} />
          <Route exact path="/categories/:idc" component={Details} />
          <Route
            exact
            path="/categories/:idc/products/:idp"
            component={Details}
          />
          <Route path="/cart" component={Cart} />
          <Route path="/congratulation" component={Congratulation} />
          <Route path="*" component={NotFound} />
        </Switch>
      </Provider>
    </BrowserRouter>
  );
}

export default App;
